<mat-form-field class="w-full">
  <mat-label>Adresse</mat-label>
  <input
    type="text"
    matInput
    placeholder="Entrez votre adresse..."
    [ngModel]="query()"
    (ngModelChange)="searchChange.emit($event)"
    [matAutocomplete]="auto"
    required
    #address="ngModel"
  />
  <mat-autocomplete #auto="matAutocomplete" [displayWith]="null">
    @for (suggestion of suggestions(); track $any(suggestion).properties?.id) {
      <mat-option
        [value]="$safeNavigationMigration($any(suggestion).properties?.label)"
        (click)="selectedAddress.emit(suggestion)"
      >
        <div class="flex flex-col py-2">
          <span class="text-sm font-medium">{{ $any(suggestion).properties?.label }}</span>
          <span class="text-xs">{{ $any(suggestion).properties?.context }}</span>
        </div>
      </mat-option>
    }
  </mat-autocomplete>
  @if (isLoading()) {
    <mat-spinner matSuffix diameter="20" class="mr-2"></mat-spinner>
  }
  @if (query()) {
    <button matSuffix mat-icon-button aria-label="Clear" (click)="cleared.emit()">
      <mat-icon>close</mat-icon>
    </button>
  } @else if (!isLoading()) {
    <mat-icon matSuffix>search</mat-icon>
  }
  @if (address.invalid && (address.dirty || address.touched)) {
    <mat-error> L'adresse est requise pour localiser votre bien </mat-error>
  }
</mat-form-field>
